// Device Layout Component Imports Helper
// This file manages all device layout component imports and provides a centralized configuration

// Import all device layout components

// Shelly Gen1 devices
import DS1NBDeviceLayout from './Devices/Shelly/Gen1/DS1NB/DS1NBDeviceLayout.svelte';
import HT1NBDeviceLayout from './Devices/Shelly/Gen1/HT1NB/HT1NBDeviceLayout.svelte';
import IRREM0DeviceLayout from './Devices/Shelly/Gen1/IR_REM-0/IR_REM-0DeviceLayout.svelte';
import MS1NBDeviceLayout from './Devices/Shelly/Gen1/MS1NB/MS1NBDeviceLayout.svelte';
import PLG1NBDeviceLayout from './Devices/Shelly/Gen1/PLG1NB/PLG1NBDeviceLayout.svelte';
import SH2LED1DeviceLayout from './Devices/Shelly/Gen1/SH2LED-1/SH2LED-1DeviceLayout.svelte';
import SHAIR1DeviceLayout from './Devices/Shelly/Gen1/SHAIR-1/SHAIR-1DeviceLayout.svelte';
import SHBDUO1DeviceLayout from './Devices/Shelly/Gen1/SHBDUO-1/SHBDUO-1DeviceLayout.svelte';
import SHBLB1DeviceLayout from './Devices/Shelly/Gen1/SHBLB-1/SHBLB-1DeviceLayout.svelte';
import SHBTN1DeviceLayout from './Devices/Shelly/Gen1/SHBTN-1/SHBTN-1DeviceLayout.svelte';
import SHBTN2DeviceLayout from './Devices/Shelly/Gen1/SHBTN-2/SHBTN-2DeviceLayout.svelte';
import SHCB1DeviceLayout from './Devices/Shelly/Gen1/SHCB-1/SHCB-1DeviceLayout.svelte';
import SHCL255DeviceLayout from './Devices/Shelly/Gen1/SHCL-255/SHCL-255DeviceLayout.svelte';
import SHDIMW1DeviceLayout from './Devices/Shelly/Gen1/SHDIMW-1/SHDIMW-1DeviceLayout.svelte';
import SHDM1DeviceLayout from './Devices/Shelly/Gen1/SHDM-1/SHDM-1DeviceLayout.svelte';
import SHDM2DeviceLayout from './Devices/Shelly/Gen1/SHDM-2/SHDM-2DeviceLayout.svelte';
import SHDW1DeviceLayout from './Devices/Shelly/Gen1/SHDW-1/SHDW-1DeviceLayout.svelte';
import SHDW2DeviceLayout from './Devices/Shelly/Gen1/SHDW-2/SHDW-2DeviceLayout.svelte';
import SHEMDeviceLayout from './Devices/Shelly/Gen1/SHEM/SHEMDeviceLayout.svelte';
import SHEM3DeviceLayout from './Devices/Shelly/Gen1/SHEM-3/SHEM-3DeviceLayout.svelte';
import SHGS1DeviceLayout from './Devices/Shelly/Gen1/SHGS-1/SHGS-1DeviceLayout.svelte';
import SHHT1DeviceLayout from './Devices/Shelly/Gen1/SHHT-1/SHHT-1DeviceLayout.svelte';
import SHIX31DeviceLayout from './Devices/Shelly/Gen1/SHIX3-1/SHIX3-1DeviceLayout.svelte';
import SHMOS01DeviceLayout from './Devices/Shelly/Gen1/SHMOS-01/SHMOS-01DeviceLayout.svelte';
import SHMOS02DeviceLayout from './Devices/Shelly/Gen1/SHMOS-02/SHMOS-02DeviceLayout.svelte';
import SHPLG1DeviceLayout from './Devices/Shelly/Gen1/SHPLG-1/SHPLG-1DeviceLayout.svelte';
import SHPLGAU1DeviceLayout from './Devices/Shelly/Gen1/SHPLG-AU1/SHPLG-AU1DeviceLayout.svelte';
import SHPLGSDeviceLayout from './Devices/Shelly/Gen1/SHPLG-S/SHPLG-SDeviceLayout.svelte';
import SHPLGU1DeviceLayout from './Devices/Shelly/Gen1/SHPLG-U1/SHPLG-U1DeviceLayout.svelte';
import SHPLGUK1DeviceLayout from './Devices/Shelly/Gen1/SHPLG-UK1/SHPLG-UK1DeviceLayout.svelte';
import SHPLG21DeviceLayout from './Devices/Shelly/Gen1/SHPLG2-1/SHPLG2-1DeviceLayout.svelte';
import SHRGBW2DeviceLayout from './Devices/Shelly/Gen1/SHRGBW2/SHRGBW2DeviceLayout.svelte';
import SHRGBWW01DeviceLayout from './Devices/Shelly/Gen1/SHRGBWW-01/SHRGBWW-01DeviceLayout.svelte';
import SHSEN1DeviceLayout from './Devices/Shelly/Gen1/SHSEN-1/SHSEN-1DeviceLayout.svelte';
import SHSM01DeviceLayout from './Devices/Shelly/Gen1/SHSM-01/SHSM-01DeviceLayout.svelte';
import SHSW1DeviceLayout from './Devices/Shelly/Gen1/SHSW-1/SHSW-1DeviceLayout.svelte';
import SHSW1SDeviceLayout from './Devices/Shelly/Gen1/SHSW-1S/SHSW-1SDeviceLayout.svelte';
import SHSW21DeviceLayout from './Devices/Shelly/Gen1/SHSW-21/SHSW-21DeviceLayout.svelte';
import SHSW22DeviceLayout from './Devices/Shelly/Gen1/SHSW-22/SHSW-22DeviceLayout.svelte';
import SHSW25DeviceLayout from './Devices/Shelly/Gen1/SHSW-25/SHSW-25DeviceLayout.svelte';
import SHSW44DeviceLayout from './Devices/Shelly/Gen1/SHSW-44/SHSW-44DeviceLayout.svelte';
import SHSWLDeviceLayout from './Devices/Shelly/Gen1/SHSW-L/SHSW-LDeviceLayout.svelte';
import SHSWPMDeviceLayout from './Devices/Shelly/Gen1/SHSW-PM/SHSW-PMDeviceLayout.svelte';
import SHTRV01DeviceLayout from './Devices/Shelly/Gen1/SHTRV-01/SHTRV-01DeviceLayout.svelte';
import SHUNI1DeviceLayout from './Devices/Shelly/Gen1/SHUNI-1/SHUNI-1DeviceLayout.svelte';
import SHVIN1DeviceLayout from './Devices/Shelly/Gen1/SHVIN-1/SHVIN-1DeviceLayout.svelte';
import SHWT1DeviceLayout from './Devices/Shelly/Gen1/SHWT-1/SHWT-1DeviceLayout.svelte';
import SMK1NBDeviceLayout from './Devices/Shelly/Gen1/SMK1NB/SMK1NBDeviceLayout.svelte';
import SNSL0A1X03WWLDeviceLayout from './Devices/Shelly/Gen1/SNSL-0A1X03WWL/SNSL-0A1X03WWLDeviceLayout.svelte';
import SNSW001X16EUDeviceLayout from './Devices/Shelly/Gen1/SNSW-001X16EU/SNSW-001X16EUDeviceLayout.svelte';
import SNSWdevX16EUDeviceLayout from './Devices/Shelly/Gen1/SNSW-devX16EU/SNSW-devX16EUDeviceLayout.svelte';
import WS1NBDeviceLayout from './Devices/Shelly/Gen1/WS1NB/WS1NBDeviceLayout.svelte';

// Shelly Gen2 devices
import SNDC0D4P10WWDeviceLayout from './Devices/Shelly/Gen2/SNDC-0D4P10WW/SNDC-0D4P10WWDeviceLayout.svelte';
import SNDM0013USDeviceLayout from './Devices/Shelly/Gen2/SNDM-0013US/SNDM-0013USDeviceLayout.svelte';
import SNPL00110EUDeviceLayout from './Devices/Shelly/Gen2/SNPL-00110EU/SNPL-00110EUDeviceLayout.svelte';
import SNPL00110ITDeviceLayout from './Devices/Shelly/Gen2/SNPL-00110IT/SNPL-00110ITDeviceLayout.svelte';
import SNPL00112EUDeviceLayout from './Devices/Shelly/Gen2/SNPL-00112EU/SNPL-00112EUDeviceLayout.svelte';
import SNPL00112UKDeviceLayout from './Devices/Shelly/Gen2/SNPL-00112UK/SNPL-00112UKDeviceLayout.svelte';
import SNPL00116ITDeviceLayout from './Devices/Shelly/Gen2/SNPL-00116IT/SNPL-00116ITDeviceLayout.svelte';
import SNPL00116USDeviceLayout from './Devices/Shelly/Gen2/SNPL-00116US/SNPL-00116USDeviceLayout.svelte';
import SNPL00210EUDeviceLayout from './Devices/Shelly/Gen2/SNPL-00210EU/SNPL-00210EUDeviceLayout.svelte';
import SNPL10112EUDeviceLayout from './Devices/Shelly/Gen2/SNPL-10112EU/SNPL-10112EUDeviceLayout.svelte';
import SNPM001PCEU16DeviceLayout from './Devices/Shelly/Gen2/SNPM-001PCEU16/SNPM-001PCEU16DeviceLayout.svelte';
import SNSN0013ADeviceLayout from './Devices/Shelly/Gen2/SNSN-0013A/SNSN-0013ADeviceLayout.svelte';
import SNSN0024XDeviceLayout from './Devices/Shelly/Gen2/SNSN-0024X/SNSN-0024XDeviceLayout.svelte';
import SNSN0043XDeviceLayout from './Devices/Shelly/Gen2/SNSN-0043X/SNSN-0043XDeviceLayout.svelte';
import SNSN0D24XDeviceLayout from './Devices/Shelly/Gen2/SNSN-0D24X/SNSN-0D24XDeviceLayout.svelte';
import S3SN0082ADeviceLayout from './Devices/Shelly/Gen2/S3SN-0082A/S3SN-0082ADeviceLayout.svelte';
import SNSW001P15ULDeviceLayout from './Devices/Shelly/Gen2/SNSW-001P15UL/SNSW-001P15ULDeviceLayout.svelte';
import SNSW001P16EUDeviceLayout from './Devices/Shelly/Gen2/SNSW-001P16EU/SNSW-001P16EUDeviceLayout.svelte';
import SNSW001P8EUDeviceLayout from './Devices/Shelly/Gen2/SNSW-001P8EU/SNSW-001P8EUDeviceLayout.svelte';
import SNSW001X15ULDeviceLayout from './Devices/Shelly/Gen2/SNSW-001X15UL/SNSW-001X15ULDeviceLayout.svelte';
import SNSW001X8EUDeviceLayout from './Devices/Shelly/Gen2/SNSW-001X8EU/SNSW-001X8EUDeviceLayout.svelte';
import SNSW002P16EUDeviceLayout from './Devices/Shelly/Gen2/SNSW-002P16EU/SNSW-002P16EUDeviceLayout.svelte';
import SNSW102P16EUDeviceLayout from './Devices/Shelly/Gen2/SNSW-102P16EU/SNSW-102P16EUDeviceLayout.svelte';
import SPCB01VENEUDeviceLayout from './Devices/Shelly/Gen3/SPCB-01VENEU/SPCB-01VENEUDeviceLayout.svelte';
import SPCB02VENEUDeviceLayout from './Devices/Shelly/Gen3/SPCB-02VENEU/SPCB-02VENEUDeviceLayout.svelte';
import SPCB03VENEUDeviceLayout from './Devices/Shelly/Gen3/SPCB-03VENEU/SPCB-03VENEUDeviceLayout.svelte';
import SPCB04VENEUDeviceLayout from './Devices/Shelly/Gen3/SPCB-04VENEU/SPCB-04VENEUDeviceLayout.svelte';
import SPDC0D5PE16EUDeviceLayout from './Devices/Shelly/Gen2/SPDC-0D5PE16EU/SPDC-0D5PE16EUDeviceLayout.svelte';
import SPDM001PE01EUDeviceLayout from './Devices/Shelly/Gen2/SPDM-001PE01EU/SPDM-001PE01EUDeviceLayout.svelte';
import SPDM002PE01EUDeviceLayout from './Devices/Shelly/Gen2/SPDM-002PE01EU/SPDM-002PE01EUDeviceLayout.svelte';
import SPEM002CEBEU50DeviceLayout from './Devices/Shelly/Gen2/SPEM-002CEBEU50/SPEM-002CEBEU50DeviceLayout.svelte';
import SPEM003CEBEUDeviceLayout from './Devices/Shelly/Gen2/SPEM-003CEBEU/SPEM-003CEBEUDeviceLayout.svelte';
import SPEM003CEBEU400DeviceLayout from './Devices/Shelly/Gen2/SPEM-003CEBEU400/SPEM-003CEBEU400DeviceLayout.svelte';
import SPEM003CEBEU63DeviceLayout from './Devices/Shelly/Gen2/SPEM-003CEBEU63/SPEM-003CEBEU63DeviceLayout.svelte';
import SPEM003REBEU2000DeviceLayout from './Devices/Shelly/Gen2/SPEM-003REBEU2000/SPEM-003REBEU2000DeviceLayout.svelte';
import SPSH002PE16EUDeviceLayout from './Devices/Shelly/Gen2/SPSH-002PE16EU/SPSH-002PE16EUDeviceLayout.svelte';
import SPSH102PE16EUDeviceLayout from './Devices/Shelly/Gen2/SPSH-102PE16EU/SPSH-102PE16EUDeviceLayout.svelte';
import SPSW001PE16EUDeviceLayout from './Devices/Shelly/Gen2/SPSW-001PE16EU/SPSW-001PE16EUDeviceLayout.svelte';
import SPSW001PE40EUDeviceLayout from './Devices/Shelly/Gen2/SPSW-001PE40EU/SPSW-001PE40EUDeviceLayout.svelte';
import SPSW001XE16EUDeviceLayout from './Devices/Shelly/Gen2/SPSW-001XE16EU/SPSW-001XE16EUDeviceLayout.svelte';
import SPSW002PE16EUDeviceLayout from './Devices/Shelly/Gen2/SPSW-002PE16EU/SPSW-002PE16EUDeviceLayout.svelte';
import SPSW002XE16EUDeviceLayout from './Devices/Shelly/Gen2/SPSW-002XE16EU/SPSW-002XE16EUDeviceLayout.svelte';
import SPSW003XE16EUDeviceLayout from './Devices/Shelly/Gen2/SPSW-003XE16EU/SPSW-003XE16EUDeviceLayout.svelte';
import SPSW004PE16EUDeviceLayout from './Devices/Shelly/Gen2/SPSW-004PE16EU/SPSW-004PE16EUDeviceLayout.svelte';
import SPSW101PE16EUDeviceLayout from './Devices/Shelly/Gen2/SPSW-101PE16EU/SPSW-101PE16EUDeviceLayout.svelte';
import SPSW101XE16EUDeviceLayout from './Devices/Shelly/Gen2/SPSW-101XE16EU/SPSW-101XE16EUDeviceLayout.svelte';
import SPSW102PE16EUDeviceLayout from './Devices/Shelly/Gen2/SPSW-102PE16EU/SPSW-102PE16EUDeviceLayout.svelte';
import SPSW102XE16EUDeviceLayout from './Devices/Shelly/Gen2/SPSW-102XE16EU/SPSW-102XE16EUDeviceLayout.svelte';
import SPSW104PE16EUDeviceLayout from './Devices/Shelly/Gen2/SPSW-104PE16EU/SPSW-104PE16EUDeviceLayout.svelte';
import SPSW201PE15ULDeviceLayout from './Devices/Shelly/Gen2/SPSW-201PE15UL/SPSW-201PE15ULDeviceLayout.svelte';
import SPSW201PE16EUDeviceLayout from './Devices/Shelly/Gen2/SPSW-201PE16EU/SPSW-201PE16EUDeviceLayout.svelte';
import SPSW201XE15ULDeviceLayout from './Devices/Shelly/Gen2/SPSW-201XE15UL/SPSW-201XE15ULDeviceLayout.svelte';
import SPSW201XE16EUDeviceLayout from './Devices/Shelly/Gen2/SPSW-201XE16EU/SPSW-201XE16EUDeviceLayout.svelte';
import SPSW202PE12ULDeviceLayout from './Devices/Shelly/Gen2/SPSW-202PE12UL/SPSW-202PE12ULDeviceLayout.svelte';
import SPSW202PE16EUDeviceLayout from './Devices/Shelly/Gen2/SPSW-202PE16EU/SPSW-202PE16EUDeviceLayout.svelte';
import SPSW202XE12ULDeviceLayout from './Devices/Shelly/Gen2/SPSW-202XE12UL/SPSW-202XE12ULDeviceLayout.svelte';
import SPSW202XE16EUDeviceLayout from './Devices/Shelly/Gen2/SPSW-202XE16EU/SPSW-202XE16EUDeviceLayout.svelte';
import SPSW204PE16EUDeviceLayout from './Devices/Shelly/Gen2/SPSW-204PE16EU/SPSW-204PE16EUDeviceLayout.svelte';
import SHPSW04PDeviceLayout from './Devices/Shelly/Gen2/SHPSW04P/SHPSW04PDeviceLayout.svelte';
import SHSPOT1DeviceLayout from './Devices/Shelly/Gen2/SHSPOT-1/SHSPOT-1DeviceLayout.svelte';

// Shelly Gen3 devices
import S3BLC010007AEUDeviceLayout from './Devices/Shelly/Gen3/S3BL-C010007AEU/S3BL-C010007AEUDeviceLayout.svelte';
import S3BLD010009AEUDeviceLayout from './Devices/Shelly/Gen3/S3BL-D010009AEU/S3BL-D010009AEUDeviceLayout.svelte';
import S3DM0010WWDeviceLayout from './Devices/Shelly/Gen3/S3DM-0010WW/S3DM-0010WWDeviceLayout.svelte';
import S3DM0A101WWLDeviceLayout from './Devices/Shelly/Gen3/S3DM-0A101WWL/S3DM-0A101WWLDeviceLayout.svelte';
import S3DM0A1WWDeviceLayout from './Devices/Shelly/Gen3/S3DM-0A1WW/S3DM-0A1WWDeviceLayout.svelte';
import S3EM002CXCEUDeviceLayout from './Devices/Shelly/Gen3/S3EM-002CXCEU/S3EM-002CXCEUDeviceLayout.svelte';
import S3EM003CXCEU63DeviceLayout from './Devices/Shelly/Gen3/S3EM-003CXCEU63/S3EM-003CXCEU63DeviceLayout.svelte';
import S3GW0D4G0EUDeviceLayout from './Devices/Shelly/Gen3/S3GW-0D4G0EU/S3GW-0D4G0EUDeviceLayout.svelte';
import S3GW1DBT001DeviceLayout from './Devices/Shelly/Gen3/S3GW-1DBT001/S3GW-1DBT001DeviceLayout.svelte';
import S3GW1DZW0EUDeviceLayout from './Devices/Shelly/Gen3/S3GW-1DZW0EU/S3GW-1DZW0EUDeviceLayout.svelte';
import S0CC0A8PME6WW0DeviceLayout from './Devices/Shelly/Gen3/S0CC-0A8PME6WW0/S0CC-0A8PME6WW0DeviceLayout.svelte';
import S3MX0ADeviceLayout from './Devices/Shelly/xmod/S3MX-0A/S3MX-0ADeviceLayout.svelte';
import S3PBO3AR000001DeviceLayout from './Devices/Shelly/Gen3/S3PB-O3AR000001/S3PB-O3AR000001DeviceLayout.svelte';
import S3PB0709114901DeviceLayout from './Devices/Shelly/Gen3/S3PB-0709114901/S3PB-0709114901DeviceLayout.svelte';
import S3PB0A15194101DeviceLayout from './Devices/Shelly/Gen3/S3PB-0A15194101/S3PB-0A15194101DeviceLayout.svelte';
import S3PL00112EUDeviceLayout from './Devices/Shelly/Gen3/S3PL-00112EU/S3PL-00112EUDeviceLayout.svelte';
import S3PL00110CNDeviceLayout from './Devices/Shelly/Gen3/S3PL-00110CN/S3PL-00110CNDeviceLayout.svelte';
import S3PL00115USDeviceLayout from './Devices/Shelly/Gen3/S3PL-00115US/S3PL-00115USDeviceLayout.svelte';
import S3PL10112EUDeviceLayout from './Devices/Shelly/Gen3/S3PL-10112EU/S3PL-10112EUDeviceLayout.svelte';
import S3PL20112EUDeviceLayout from './Devices/Shelly/Gen3/S3PL-20112EU/S3PL-20112EUDeviceLayout.svelte';
import S3PL30110EUDeviceLayout from './Devices/Shelly/Gen4/S3PL-30110EU/S3PL-30110EUDeviceLayout.svelte';
import S3PL30116EUDeviceLayout from './Devices/Shelly/Gen3/S3PL-30116EU/S3PL-30116EUDeviceLayout.svelte';
import S3PM001PCEU16DeviceLayout from './Devices/Shelly/Gen3/S3PM-001PCEU16/S3PM-001PCEU16DeviceLayout.svelte';
import S3SH0A2P4EUDeviceLayout from './Devices/Shelly/Gen3/S3SH-0A2P4EU/S3SH-0A2P4EUDeviceLayout.svelte';
import S3SN0024XDeviceLayout from './Devices/Shelly/Gen3/S3SN-0024X/S3SN-0024XDeviceLayout.svelte';
import S3SN0D24XDeviceLayout from './Devices/Shelly/Gen3/S3SN-0D24X/S3SN-0D24XDeviceLayout.svelte';
import S3SN0U12ADeviceLayout from './Devices/Shelly/Gen3/S3SN-0U12A/S3SN-0U12ADeviceLayout.svelte';
import S3SN0U53XDeviceLayout from './Devices/Shelly/Gen3/S3SN-0U53X/S3SN-0U53XDeviceLayout.svelte';
import S3SN1U12ADeviceLayout from './Devices/Shelly/Gen3/S3SN-1U12A/S3SN-1U12ADeviceLayout.svelte';
import S3SW001P16EUDeviceLayout from './Devices/Shelly/Gen3/S3SW-001P16EU/S3SW-001P16EUDeviceLayout.svelte';
import S3SW001P16SPDeviceLayout from './Devices/Shelly/Gen3/S3SW-001P16SP/S3SW-001P16SPDeviceLayout.svelte';
import S3SW001P8EUDeviceLayout from './Devices/Shelly/Gen3/S3SW-001P8EU/S3SW-001P8EUDeviceLayout.svelte';
import S3SW001X16EUDeviceLayout from './Devices/Shelly/Gen3/S3SW-001X16EU/S3SW-001X16EUDeviceLayout.svelte';
import S3SW001X8EUDeviceLayout from './Devices/Shelly/Gen3/S3SW-001X8EU/S3SW-001X8EUDeviceLayout.svelte';
import S3SW002P16EUDeviceLayout from './Devices/Shelly/Gen3/S3SW-002P16EU/S3SW-002P16EUDeviceLayout.svelte';
import S3SW0A1X1EULDeviceLayout from './Devices/Shelly/Gen3/S3SW-0A1X1EUL/S3SW-0A1X1EULDeviceLayout.svelte';
import S3SW0A1X5USDeviceLayout from './Devices/Shelly/Gen3/S3SW-0A1X5US/S3SW-0A1X5USDeviceLayout.svelte';
import S3SW0A2X4EULDeviceLayout from './Devices/Shelly/Gen3/S3SW-0A2X4EUL/S3SW-0A2X4EULDeviceLayout.svelte';
import S3SW1A1X5USDeviceLayout from './Devices/Shelly/Gen3/S3SW-1A1X5US/S3SW-1A1X5USDeviceLayout.svelte';
import S4SN0031ZDeviceLayout from './Devices/Shelly/Gen3/S4SN-0031Z/S4SN-0031ZDeviceLayout.svelte';
import S4SN1031ZDeviceLayout from './Devices/Shelly/Gen3/S4SN-1031Z/S4SN-1031ZDeviceLayout.svelte';
import SNDM00100WWDeviceLayout from './Devices/Shelly/Gen3/SNDM-00100WW/SNDM-00100WWDeviceLayout.svelte';
import SNDM9995WWDeviceLayout from './Devices/Shelly/Gen3/SNDM-9995WW/SNDM-9995WWDeviceLayout.svelte';
import SNSL0A2X03WWLDeviceLayout from './Devices/Shelly/Gen3/SNSL-0A2X03WWL/SNSL-0A2X03WWLDeviceLayout.svelte';
import SNSN0031ZDeviceLayout from './Devices/Shelly/Gen3/SNSN-0031Z/SNSN-0031ZDeviceLayout.svelte';
import SNSW002X16EUDeviceLayout from './Devices/Shelly/Gen3/SNSW-002X16EU/SNSW-002X16EUDeviceLayout.svelte';
import SPCC001PE10EUDeviceLayout from './Devices/Shelly/Gen3/SPCC-001PE10EU/SPCC-001PE10EUDeviceLayout.svelte';

// Shelly Gen4 devices
import S4DM0010WWDeviceLayout from './Devices/Shelly/Gen4/S4DM-0010WW/S4DM-0010WWDeviceLayout.svelte';
import S4DM0A101WWLDeviceLayout from './Devices/Shelly/Gen4/S4DM-0A101WWL/S4DM-0A101WWLDeviceLayout.svelte';
import S4DM0A102USDeviceLayout from './Devices/Shelly/Gen4/S4DM-0A102US/S4DM-0A102USDeviceLayout.svelte';
import S4EM001CXCEU63DeviceLayout from './Devices/Shelly/Gen4/S4EM-001CXCEU63/S4EM-001CXCEU63DeviceLayout.svelte';
import S4EM001PXCEU16DeviceLayout from './Devices/Shelly/Gen4/S4EM-001PXCEU16/S4EM-001PXCEU16DeviceLayout.svelte';
import S4EM002CXCEUDeviceLayout from './Devices/Shelly/Gen4/S4EM-002CXCEU/S4EM-002CXCEUDeviceLayout.svelte';
import S4EM003RXCEU63DeviceLayout from './Devices/Shelly/Gen4/S4EM-003RXCEU63/S4EM-003RXCEU63DeviceLayout.svelte';
import S4PB00CU000002DeviceLayout from './Devices/Shelly/Gen4/S4PB-00CU000002/S4PB-00CU000002DeviceLayout.svelte';
import S4PB06A7000101DeviceLayout from './Devices/Shelly/Gen4/S4PB-06A7000101/S4PB-06A7000101DeviceLayout.svelte';
import S4PB0916176901DeviceLayout from './Devices/Shelly/Gen4/S4PB-0916176901/S4PB-0916176901DeviceLayout.svelte';
import S4CC0D1XX1WW1DeviceLayout from './Devices/Shelly/Gen4/S4CC-0D1XX1WW1/S4CC-0D1XX1WW1DeviceLayout.svelte';
import IRDeviceLayout from './Devices/Shelly/Gen4/S4CC-0D1XX1WW1/IRDevice/IRDeviceLayout.svelte';
import S4PL00114EUDeviceLayout from './Devices/Shelly/Gen4/S4PL-00114EU/S4PL-00114EUDeviceLayout.svelte';
import S4PL00116EUDeviceLayout from './Devices/Shelly/Gen4/S4PL-00116EU/S4PL-00116EUDeviceLayout.svelte';
import S4PL00116USDeviceLayout from './Devices/Shelly/Gen4/S4PL-00116US/S4PL-00116USDeviceLayout.svelte';
import S4PL00415USDeviceLayout from './Devices/Shelly/Gen4/S4PL-00415US/S4PL-00415USDeviceLayout.svelte';
import S4PL00416EUDeviceLayout from './Devices/Shelly/Gen4/S4PL-00416EU/S4PL-00416EUDeviceLayout.svelte';
import S4SN0071ADeviceLayout from './Devices/Shelly/Gen4/S4SN-0071A/S4SN-0071ADeviceLayout.svelte';
import S4SN0071ZDeviceLayout from './Devices/Shelly/Gen4/S4SN-0071Z/S4SN-0071ZDeviceLayout.svelte';
import S4SN0A24XDeviceLayout from './Devices/Shelly/Gen4/S4SN-0A24X/S4SN-0A24XDeviceLayout.svelte';
import S4SN0D24XDeviceLayout from './Devices/Shelly/Gen4/S4SN-0D24X/S4SN-0D24XDeviceLayout.svelte';
import S4SN0A61XDeviceLayout from './Devices/Shelly/Gen4/S4SN-0A61X/S4SN-0A61XDeviceLayout.svelte';
import S4SN0U61XDeviceLayout from './Devices/Shelly/Gen4/S4SN-0U61X/S4SN-0U61XDeviceLayout.svelte';
import S4SW001P16EUDeviceLayout from './Devices/Shelly/Gen4/S4SW-001P16EU/S4SW-001P16EUDeviceLayout.svelte';
import S4SW001P8EUDeviceLayout from './Devices/Shelly/Gen4/S4SW-001P8EU/S4SW-001P8EUDeviceLayout.svelte';
import S4SW001X16EUDeviceLayout from './Devices/Shelly/Gen4/S4SW-001X16EU/S4SW-001X16EUDeviceLayout.svelte';
import S4SW001X8EUDeviceLayout from './Devices/Shelly/Gen4/S4SW-001X8EU/S4SW-001X8EUDeviceLayout.svelte';
import S4SW002P16EUDeviceLayout from './Devices/Shelly/Gen4/S4SW-002P16EU/S4SW-002P16EUDeviceLayout.svelte';
import S4SW0A1X1EULDeviceLayout from './Devices/Shelly/Gen4/S4SW-0A1X1EUL/S4SW-0A1X1EULDeviceLayout.svelte';
import S4SW0A2X4EULDeviceLayout from './Devices/Shelly/Gen4/S4SW-0A2X4EUL/S4SW-0A2X4EULDeviceLayout.svelte';

// Shelly BLE devices
import SBBT002CDeviceLayout from './Devices/Shelly/BLE/SBBT-002C/SBBT-002CDeviceLayout.svelte';
import SBBT004CDeviceLayout from './Devices/Shelly/BLE/SBBT-004C/SBBT-004CDeviceLayout.svelte';
import SBBT004CEUDeviceLayout from './Devices/Shelly/BLE/SBBT-004CEU/SBBT-004CEUDeviceLayout.svelte';
import SBBT004CUSDeviceLayout from './Devices/Shelly/BLE/SBBT-004CUS/SBBT-004CUSDeviceLayout.svelte';
import SBBT102CDeviceLayout from './Devices/Shelly/BLE/SBBT-102C/SBBT-102CDeviceLayout.svelte';
import SBBT104CEUDeviceLayout from './Devices/Shelly/BLE/SBBT-104CEU/SBBT-104CEUDeviceLayout.svelte';
import SBBT104CUSDeviceLayout from './Devices/Shelly/BLE/SBBT-104CUS/SBBT-104CUSDeviceLayout.svelte';
import SBDI003EDeviceLayout from './Devices/Shelly/BLE/SBDI-003E/SBDI-003EDeviceLayout.svelte';
import SBDS002ADeviceLayout from './Devices/Shelly/BLE/SBDS-002A/SBDS-002ADeviceLayout.svelte';
import SBDW002CDeviceLayout from './Devices/Shelly/BLE/SBDW-002C/SBDW-002CDeviceLayout.svelte';
import SBDW103CDeviceLayout from './Devices/Shelly/BLE/SBDW-103C/SBDW-103CDeviceLayout.svelte';
import SBDW203CDeviceLayout from './Devices/Shelly/BLE/SBDW-203C/SBDW-203CDeviceLayout.svelte';
import SBDW302CDeviceLayout from './Devices/Shelly/BLE/SBDW-302C/SBDW-302CDeviceLayout.svelte';
import SBHT003CDeviceLayout from './Devices/Shelly/BLE/SBHT-003C/SBHT-003CDeviceLayout.svelte';
import SBHT103CDeviceLayout from './Devices/Shelly/BLE/SBHT-103C/SBHT-103CDeviceLayout.svelte';
import SBHT203CDeviceLayout from './Devices/Shelly/BLE/SBHT-203C/SBHT-203CDeviceLayout.svelte';
import SBMS001ADeviceLayout from './Devices/Shelly/BLE/SBMS-001A/SBMS-001ADeviceLayout.svelte';
import SBMO003ZDeviceLayout from './Devices/Shelly/BLE/SBMO-003Z/SBMO-003ZDeviceLayout.svelte';
import SBMO103ZDeviceLayout from './Devices/Shelly/BLE/SBMO-103Z/SBMO-103ZDeviceLayout.svelte';
import SBRC005BDeviceLayout from './Devices/Shelly/BLE/SBRC-005B/SBRC-005BDeviceLayout.svelte';
import SBRK002CDeviceLayout from './Devices/Shelly/BLE/SBRK-002C/SBRK-002CDeviceLayout.svelte';
import SBSN001BDeviceLayout from './Devices/Shelly/BLE/SBSN-001B/SBSN-001BDeviceLayout.svelte';
import SBTR001AEUDeviceLayout from './Devices/Shelly/BLE/SBTR-001AEU/SBTR-001AEUDeviceLayout.svelte';
import SBWS90CMDeviceLayout from './Devices/Shelly/BLE/SBWS-90CM/SBWS-90CMDeviceLayout.svelte';
import SNGWBT01DeviceLayout from './Devices/Shelly/BLE/SNGW-BT01/SNGW-BT01DeviceLayout.svelte';
import SMSN0031ZLDeviceLayout from './Devices/Shelly/BLE/SMSN-0031ZL/SMSN-0031ZLDeviceLayout.svelte';

// Shelly xmod devices
import S3XT0SDeviceLayout from './Devices/Shelly/xmod/S3XT-0S/S3XT-0SDeviceLayout.svelte';

// EcoFlow devices
import EF3PL00112EUDeviceLayout from './Devices/EcoFlow/EF3PL-00112EU/EF3PL-00112EUDeviceLayout.svelte';
import EFNPL00112UKDeviceLayout from './Devices/EcoFlow/EFNPL-00112UK/EFNPL-00112UKDeviceLayout.svelte';
import EFPEM003CEBEU120DeviceLayout from './Devices/EcoFlow/EFPEM-003CEBEU120/EFPEM-003CEBEU120DeviceLayout.svelte';
import XPZACE1500DeviceLayout from './Devices/EcoFlow/XPZ-ACE1500/XPZ-ACE1500DeviceLayout.svelte';
import XPZAIO2400DeviceLayout from './Devices/EcoFlow/XPZ-AIO2400/XPZ-AIO2400DeviceLayout.svelte';
import XPZHUB1200DeviceLayout from './Devices/EcoFlow/XPZ-HUB1200/XPZ-HUB1200DeviceLayout.svelte';
import XPZHYPER2000DeviceLayout from './Devices/EcoFlow/XPZ-HYPER2000/XPZ-HYPER2000DeviceLayout.svelte';
import XPZSOLARFLOWDeviceLayout from './Devices/EcoFlow/XPZ-SOLARFLOW/XPZ-SOLARFLOWDeviceLayout.svelte';
import XPZSOLARFLOW1200DeviceLayout from './Devices/EcoFlow/XPZ-SOLARFLOW1200/XPZ-SOLARFLOW1200DeviceLayout.svelte';
import XPZSOLARFLOW2000DeviceLayout from './Devices/EcoFlow/XPZ-SOLARFLOW2000/XPZ-SOLARFLOW2000DeviceLayout.svelte';

// LoQed devices
import LOQEDDeviceLayout from './Devices/Loqed/LOQEDDeviceLayout.svelte';

// Virtual devices
import bthomedeviceDeviceLayout from './Devices/Virtual/bthome-device/bthome-deviceDeviceLayout.svelte';
import IRREM1remoteDeviceLayout from './Devices/Virtual/IR_REM-1-remote/IR_REM-1-remoteDeviceLayout.svelte';
import peripheraldeviceDeviceLayout from './Devices/Virtual/peripheral-device/peripheral-deviceDeviceLayout.svelte';
import virtualgroupDeviceLayout from './Devices/Virtual/virtual-group/virtual-groupDeviceLayout.svelte';

// Android devices
import SAWD0A1XX10EU1DeviceLayout from './Devices/Android/SAWD-0A1XX10EU1/SAWD-0A1XX10EU1DeviceLayout.svelte';
import SAWD1A1XX10EU1DeviceLayout from './Devices/Android/SAWD-1A1XX10EU1/SAWD-1A1XX10EU1DeviceLayout.svelte';
import SAWD2A1XX10EU1DeviceLayout from './Devices/Android/SAWD-2A1XX10EU1/SAWD-2A1XX10EU1DeviceLayout.svelte';
import SAWD3A1XE10EU2DeviceLayout from './Devices/Android/SAWD-3A1XE10EU2/SAWD-3A1XE10EU2DeviceLayout.svelte';
import SAWD3A2XE10EU2DeviceLayout from './Devices/Android/SAWD-3A2XE10EU2/SAWD-3A2XE10EU2DeviceLayout.svelte';
import SAWD4A1XE10US0DeviceLayout from './Devices/Android/SAWD-4A1XE10US0/SAWD-4A1XE10US0DeviceLayout.svelte';
import SAWD5A1XX10EU0DeviceLayout from './Devices/Android/SAWD-5A1XX10EU0/SAWD-5A1XX10EU0DeviceLayout.svelte';
import SAWD6A1XX10EU0DeviceLayout from './Devices/Android/SAWD-6A1XX10EU0/SAWD-6A1XX10EU0DeviceLayout.svelte';

// Camera devices
import CameraDeviceLayout from 'src/components/Camera/SidepanelLayout/CameraDeviceLayout.svelte';

// Device Layout Configuration Object
const DEVICE_SIDE_PANEL_LAYOUT_CONFIG = {
	DS1NB: DS1NBDeviceLayout,
	'EF3PL-00112EU': EF3PL00112EUDeviceLayout,
	'EFNPL-00112UK': EFNPL00112UKDeviceLayout,
	'EFPEM-003CEBEU120': EFPEM003CEBEU120DeviceLayout,
	HT1NB: HT1NBDeviceLayout,
	'IR_REM-0': IRREM0DeviceLayout,
	'IR_REM-1-remote': IRREM1remoteDeviceLayout,
	LOQED: LOQEDDeviceLayout,
	MS1NB: MS1NBDeviceLayout,
	PLG1NB: PLG1NBDeviceLayout,
	'S1CM-0DXW00': CameraDeviceLayout,
	'S3BL-C010007AEU': S3BLC010007AEUDeviceLayout,
	'S3BL-D010009AEU': S3BLD010009AEUDeviceLayout,
	'S3DM-0010WW': S3DM0010WWDeviceLayout,
	'S3DM-0A101WWL': S3DM0A101WWLDeviceLayout,
	'S3DM-0A1WW': S3DM0A1WWDeviceLayout,
	'S3EM-002CXCEU': S3EM002CXCEUDeviceLayout,
	'S3EM-003CXCEU63': S3EM003CXCEU63DeviceLayout,
	'S3GW-0D4G0EU': S3GW0D4G0EUDeviceLayout,
	'S3GW-1DBT001': S3GW1DBT001DeviceLayout,
	'S3GW-1DZW0EU': S3GW1DZW0EUDeviceLayout,
	'S0CC-0A8PME6WW0': S0CC0A8PME6WW0DeviceLayout,
	'S3MX-0A': S3MX0ADeviceLayout,
	'S3PB-O3AR000001': S3PBO3AR000001DeviceLayout,
	'S3PB-0709114901': S3PB0709114901DeviceLayout,
	'S3PB-0A15194101': S3PB0A15194101DeviceLayout,
	'S3PL-00112EU': S3PL00112EUDeviceLayout,
	'S3PL-00110CN': S3PL00110CNDeviceLayout,
	'S3PL-00115US': S3PL00115USDeviceLayout,
	'S3PL-10112EU': S3PL10112EUDeviceLayout,
	'S3PL-20112EU': S3PL20112EUDeviceLayout,
	'S3PL-30110EU': S3PL30110EUDeviceLayout,
	'S3PL-30116EU': S3PL30116EUDeviceLayout,
	'S3PM-001PCEU16': S3PM001PCEU16DeviceLayout,
	'S3SH-0A2P4EU': S3SH0A2P4EUDeviceLayout,
	'S3SN-0024X': S3SN0024XDeviceLayout,
	'S3SN-0D24X': S3SN0D24XDeviceLayout,
	'S3SN-0U12A': S3SN0U12ADeviceLayout,
	'S3SN-0U53X': S3SN0U53XDeviceLayout,
	'S3SN-1U12A': S3SN1U12ADeviceLayout,
	'S3SW-001P16EU': S3SW001P16EUDeviceLayout,
	'S3SW-001P16SP': S3SW001P16SPDeviceLayout,
	'S3SW-001P8EU': S3SW001P8EUDeviceLayout,
	'S3SW-001X16EU': S3SW001X16EUDeviceLayout,
	'S3SW-001X8EU': S3SW001X8EUDeviceLayout,
	'S3SW-002P16EU': S3SW002P16EUDeviceLayout,
	'S3SW-0A1X1EUL': S3SW0A1X1EULDeviceLayout,
	'S3SW-0A1X5US': S3SW0A1X5USDeviceLayout,
	'S3SW-0A2X4EUL': S3SW0A2X4EULDeviceLayout,
	'S3SW-1A1X5US': S3SW1A1X5USDeviceLayout,
	'S3XT-0S': S3XT0SDeviceLayout,
	'S4DM-0010WW': S4DM0010WWDeviceLayout,
	'S4DM-0A101WWL': S4DM0A101WWLDeviceLayout,
	'S4DM-0A102US': S4DM0A102USDeviceLayout,
	'S4EM-001CXCEU63': S4EM001CXCEU63DeviceLayout,
	'S4EM-001PXCEU16': S4EM001PXCEU16DeviceLayout,
	'S4EM-002CXCEU': S4EM002CXCEUDeviceLayout,
	'S4EM-003RXCEU63': S4EM003RXCEU63DeviceLayout,
	'S4PB-00CU000002': S4PB00CU000002DeviceLayout,
	'S4PB-06A7000101': S4PB06A7000101DeviceLayout,
	'S4PB-0916176901': S4PB0916176901DeviceLayout,
	'S4CC-0D1XX1WW1': S4CC0D1XX1WW1DeviceLayout,
	'S4PL-00114EU': S4PL00114EUDeviceLayout,
	'S4PL-00116EU': S4PL00116EUDeviceLayout,
	'S4PL-00116US': S4PL00116USDeviceLayout,
	'S4PL-00415US': S4PL00415USDeviceLayout,
	'S4PL-00416EU': S4PL00416EUDeviceLayout,
	'S4SN-0031Z': S4SN0031ZDeviceLayout,
	'S4SN-0071A': S4SN0071ADeviceLayout,
	'S4SN-0071Z': S4SN0071ZDeviceLayout,
	'S4SN-0A24X': S4SN0A24XDeviceLayout,
	'S4SN-0A61X': S4SN0A61XDeviceLayout,
	'S4SN-0D24X': S4SN0D24XDeviceLayout,
	'S4SN-0U61X': S4SN0U61XDeviceLayout,
	'S4SN-1031Z': S4SN1031ZDeviceLayout,
	'S4SW-001P16EU': S4SW001P16EUDeviceLayout,
	'S4SW-001P8EU': S4SW001P8EUDeviceLayout,
	'S4SW-001X16EU': S4SW001X16EUDeviceLayout,
	'S4SW-001X8EU': S4SW001X8EUDeviceLayout,
	'S4SW-002P16EU': S4SW002P16EUDeviceLayout,
	'S4SW-0A1X1EUL': S4SW0A1X1EULDeviceLayout,
	'S4SW-0A2X4EUL': S4SW0A2X4EULDeviceLayout,
	'SACM-0A0XX0EU0': CameraDeviceLayout,
	'SAWD-0A1XX10EU1': SAWD0A1XX10EU1DeviceLayout,
	'SAWD-1A1XX10EU1': SAWD1A1XX10EU1DeviceLayout,
	'SAWD-2A1XX10EU1': SAWD2A1XX10EU1DeviceLayout,
	'SAWD-3A1XE10EU2': SAWD3A1XE10EU2DeviceLayout,
	'SAWD-3A2XE10EU2': SAWD3A2XE10EU2DeviceLayout,
	'SAWD-4A1XE10US0': SAWD4A1XE10US0DeviceLayout,
	'SAWD-5A1XX10EU0': SAWD5A1XX10EU0DeviceLayout,
	'SAWD-6A1XX10EU0': SAWD6A1XX10EU0DeviceLayout,
	'SBBT-002C': SBBT002CDeviceLayout,
	'SBBT-004C': SBBT004CDeviceLayout,
	'SBBT-004CEU': SBBT004CEUDeviceLayout,
	'SBBT-004CUS': SBBT004CUSDeviceLayout,
	'SBBT-102C': SBBT102CDeviceLayout,
	'SBBT-102CEU': SBBT104CEUDeviceLayout,
	'SBBT-104CEU': SBBT104CEUDeviceLayout,
	'SBBT-104CUS': SBBT104CUSDeviceLayout,
	'SBDI-003E': SBDI003EDeviceLayout,
	'SBDS-002A': SBDS002ADeviceLayout,
	'SBDW-002C': SBDW002CDeviceLayout,
	'SBDW-103C': SBDW103CDeviceLayout,
	'SBDW-203C': SBDW203CDeviceLayout,
	'SBDW-302C': SBDW302CDeviceLayout,
	'SBHT-003C': SBHT003CDeviceLayout,
	'SBHT-103C': SBHT103CDeviceLayout,
	'SBHT-203C': SBHT203CDeviceLayout,
	'SBMS-001A': SBMS001ADeviceLayout,
	'SBMO-003Z': SBMO003ZDeviceLayout,
	'SBMO-103Z': SBMO103ZDeviceLayout,
	'SBRC-005B': SBRC005BDeviceLayout,
	'SBRK-002C': SBRK002CDeviceLayout,
	'SBSN-001B': SBSN001BDeviceLayout,
	'SBTR-001AEU': SBTR001AEUDeviceLayout,
	'SBWS-90CM': SBWS90CMDeviceLayout,
	'SH2LED-1': SH2LED1DeviceLayout,
	'SHAIR-1': SHAIR1DeviceLayout,
	'SHBDUO-1': SHBDUO1DeviceLayout,
	'SHBLB-1': SHBLB1DeviceLayout,
	'SHBTN-1': SHBTN1DeviceLayout,
	'SHBTN-2': SHBTN2DeviceLayout,
	'SHCB-1': SHCB1DeviceLayout,
	'SHCL-255': SHCL255DeviceLayout,
	'SHDIMW-1': SHDIMW1DeviceLayout,
	'SHDM-1': SHDM1DeviceLayout,
	'SHDM-2': SHDM2DeviceLayout,
	'SHDW-1': SHDW1DeviceLayout,
	'SHDW-2': SHDW2DeviceLayout,
	SHEM: SHEMDeviceLayout,
	'SHEM-3': SHEM3DeviceLayout,
	'SHGS-1': SHGS1DeviceLayout,
	'SHHT-1': SHHT1DeviceLayout,
	'SHIX3-1': SHIX31DeviceLayout,
	'SHMOS-01': SHMOS01DeviceLayout,
	'SHMOS-02': SHMOS02DeviceLayout,
	'SHPLG-1': SHPLG1DeviceLayout,
	'SHPLG-AU1': SHPLGAU1DeviceLayout,
	'SHPLG-S': SHPLGSDeviceLayout,
	'SHPLG-U1': SHPLGU1DeviceLayout,
	'SHPLG-UK1': SHPLGUK1DeviceLayout,
	'SHPLG2-1': SHPLG21DeviceLayout,
	SHPSW04P: SHPSW04PDeviceLayout,
	SHRGBW2: SHRGBW2DeviceLayout,
	'SHRGBWW-01': SHRGBWW01DeviceLayout,
	'SHSEN-1': SHSEN1DeviceLayout,
	'SHSM-01': SHSM01DeviceLayout,
	'SHSPOT-1': SHSPOT1DeviceLayout,
	'SHSW-1': SHSW1DeviceLayout,
	'SHSW-1S': SHSW1SDeviceLayout,
	'SHSW-21': SHSW21DeviceLayout,
	'SHSW-22': SHSW22DeviceLayout,
	'SHSW-25': SHSW25DeviceLayout,
	'SHSW-44': SHSW44DeviceLayout,
	'SHSW-L': SHSWLDeviceLayout,
	'SHSW-PM': SHSWPMDeviceLayout,
	'SHTRV-01': SHTRV01DeviceLayout,
	'SHUNI-1': SHUNI1DeviceLayout,
	'SHVIN-1': SHVIN1DeviceLayout,
	'SHWT-1': SHWT1DeviceLayout,
	SMK1NB: SMK1NBDeviceLayout,
	'SMSN-0031ZL': SMSN0031ZLDeviceLayout,
	'SNDC-0D4P10WW': SNDC0D4P10WWDeviceLayout,
	'SNDM-00100WW': SNDM00100WWDeviceLayout,
	'SNDM-0013US': SNDM0013USDeviceLayout,
	'SNDM-9995WW': SNDM9995WWDeviceLayout,
	'SNGW-BT01': SNGWBT01DeviceLayout,
	'SNPL-00110EU': SNPL00110EUDeviceLayout,
	'SNPL-00110IT': SNPL00110ITDeviceLayout,
	'SNPL-00112EU': SNPL00112EUDeviceLayout,
	'SNPL-00112UK': SNPL00112UKDeviceLayout,
	'SNPL-00116IT': SNPL00116ITDeviceLayout,
	'SNPL-00116US': SNPL00116USDeviceLayout,
	'SNPL-00210EU': SNPL00210EUDeviceLayout,
	'SNPL-10112EU': SNPL10112EUDeviceLayout,
	'SNPM-001PCEU16': SNPM001PCEU16DeviceLayout,
	'SNSL-0A1X03WWL': SNSL0A1X03WWLDeviceLayout,
	'SNSL-0A2X03WWL': SNSL0A2X03WWLDeviceLayout,
	'SNSN-0013A': SNSN0013ADeviceLayout,
	'SNSN-0024X': SNSN0024XDeviceLayout,
	'SNSN-0031Z': SNSN0031ZDeviceLayout,
	'SNSN-0043X': SNSN0043XDeviceLayout,
	'SNSN-0D24X': SNSN0D24XDeviceLayout,
	'S3SN-0082A': S3SN0082ADeviceLayout,
	'SNSW-001P15UL': SNSW001P15ULDeviceLayout,
	'SNSW-001P16EU': SNSW001P16EUDeviceLayout,
	'SNSW-001P8EU': SNSW001P8EUDeviceLayout,
	'SNSW-001X15UL': SNSW001X15ULDeviceLayout,
	'SNSW-001X16EU': SNSW001X16EUDeviceLayout,
	'SNSW-001X8EU': SNSW001X8EUDeviceLayout,
	'SNSW-002P16EU': SNSW002P16EUDeviceLayout,
	'SNSW-002X16EU': SNSW002X16EUDeviceLayout,
	'SNSW-102P16EU': SNSW102P16EUDeviceLayout,
	'SNSW-devX16EU': SNSWdevX16EUDeviceLayout,
	'SPCB-01VENEU': SPCB01VENEUDeviceLayout,
	'SPCB-02VENEU': SPCB02VENEUDeviceLayout,
	'SPCB-03VENEU': SPCB03VENEUDeviceLayout,
	'SPCB-04VENEU': SPCB04VENEUDeviceLayout,
	'SPCC-001PE10EU': SPCC001PE10EUDeviceLayout,
	'SPDC-0D5PE16EU': SPDC0D5PE16EUDeviceLayout,
	'SPDM-001PE01EU': SPDM001PE01EUDeviceLayout,
	'SPDM-002PE01EU': SPDM002PE01EUDeviceLayout,
	'SPEM-002CEBEU50': SPEM002CEBEU50DeviceLayout,
	'SPEM-003CEBEU': SPEM003CEBEUDeviceLayout,
	'SPEM-003CEBEU400': SPEM003CEBEU400DeviceLayout,
	'SPEM-003CEBEU63': SPEM003CEBEU63DeviceLayout,
	'SPEM-003REBEU2000': SPEM003REBEU2000DeviceLayout,
	'SPSH-002PE16EU': SPSH002PE16EUDeviceLayout,
	'SPSH-102PE16EU': SPSH102PE16EUDeviceLayout,
	'SPSW-001PE16EU': SPSW001PE16EUDeviceLayout,
	'SPSW-001PE40EU': SPSW001PE40EUDeviceLayout,
	'SPSW-001XE16EU': SPSW001XE16EUDeviceLayout,
	'SPSW-002PE16EU': SPSW002PE16EUDeviceLayout,
	'SPSW-002XE16EU': SPSW002XE16EUDeviceLayout,
	'SPSW-003XE16EU': SPSW003XE16EUDeviceLayout,
	'SPSW-004PE16EU': SPSW004PE16EUDeviceLayout,
	'SPSW-101PE16EU': SPSW101PE16EUDeviceLayout,
	'SPSW-101XE16EU': SPSW101XE16EUDeviceLayout,
	'SPSW-102PE16EU': SPSW102PE16EUDeviceLayout,
	'SPSW-102XE16EU': SPSW102XE16EUDeviceLayout,
	'SPSW-104PE16EU': SPSW104PE16EUDeviceLayout,
	'SPSW-201PE15UL': SPSW201PE15ULDeviceLayout,
	'SPSW-201PE16EU': SPSW201PE16EUDeviceLayout,
	'SPSW-201XE15UL': SPSW201XE15ULDeviceLayout,
	'SPSW-201XE16EU': SPSW201XE16EUDeviceLayout,
	'SPSW-202PE12UL': SPSW202PE12ULDeviceLayout,
	'SPSW-202PE16EU': SPSW202PE16EUDeviceLayout,
	'SPSW-202XE12UL': SPSW202XE12ULDeviceLayout,
	'SPSW-202XE16EU': SPSW202XE16EUDeviceLayout,
	'SPSW-204PE16EU': SPSW204PE16EUDeviceLayout,
	WS1NB: WS1NBDeviceLayout,
	'XPZ-ACE1500': XPZACE1500DeviceLayout,
	'XPZ-AIO2400': XPZAIO2400DeviceLayout,
	'XPZ-HUB1200': XPZHUB1200DeviceLayout,
	'XPZ-HYPER2000': XPZHYPER2000DeviceLayout,
	'XPZ-SOLARFLOW': XPZSOLARFLOWDeviceLayout,
	'XPZ-SOLARFLOW1200': XPZSOLARFLOW1200DeviceLayout,
	'XPZ-SOLARFLOW2000': XPZSOLARFLOW2000DeviceLayout,
	'bthome-device': bthomedeviceDeviceLayout,
	'ir-device': IRDeviceLayout,
	'peripheral-device': peripheraldeviceDeviceLayout,
	'virtual-group': virtualgroupDeviceLayout,
};
export default DEVICE_SIDE_PANEL_LAYOUT_CONFIG;

// Helper function to get a device layout component by device type
export function getDeviceLayoutComponent(deviceType: string) {
	return DEVICE_SIDE_PANEL_LAYOUT_CONFIG[deviceType] || null;
}

// Export list of all supported device types
export const SUPPORTED_DEVICE_TYPES = Object.keys(DEVICE_SIDE_PANEL_LAYOUT_CONFIG);
